import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[580px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20modern%20elegant%20smartphone%20floating%20in%20a%20warm%20minimalist%20abstract%20environment%2C%20soft%20golden%20and%20cream%20gradient%20background%20with%20subtle%20geometric%20patterns%2C%20premium%20app%20launch%20hero%20visual%2C%20warm%20ambient%20glow%2C%20clean%20sophisticated%20aesthetic%2C%20artistic%20composition%20with%20gentle%20light%20rays%2C%20no%20blue%20or%20purple%20tones&width=1800&height=800&seq=hero-bg-2026&orientation=landscape"
          alt="皇冠App官方正版 - 安全稳定移动应用平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-shield-check-line text-sm text-accent-300"></i>
            </div>
            <span className="text-sm text-background-50/90 font-medium">官方正版 · 安全认证 · 千万用户信赖</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-4 leading-tight">
            皇冠App官方下载
          </h1>
          <p className="text-base md:text-lg text-background-50/80 mb-8 max-w-xl mx-auto leading-relaxed">
            正版安全体验，稳定流畅运行。皇冠App为您提供安全可靠的移动应用平台，
            多重防护保障隐私安全，全新界面设计带来极致操作体验。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#download"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-medium text-base rounded-md hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-2-line text-lg w-4 h-4 flex items-center justify-center"></i>
              立即下载
            </a>
            <Link
              to="/category/guide"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50/10 backdrop-blur-sm text-background-50 font-medium text-base rounded-md border border-background-50/25 hover:bg-background-50/20 transition-all duration-200 whitespace-nowrap"
            >
              <i className="ri-book-open-line text-lg w-4 h-4 flex items-center justify-center"></i>
              使用指南
            </Link>
          </div>

          <div className="flex items-center justify-center gap-8 mt-10">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">1000万+</p>
              <p className="text-xs text-background-50/60 mt-1">累计用户</p>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">4.8</p>
              <p className="text-xs text-background-50/60 mt-1">用户评分</p>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">99.9%</p>
              <p className="text-xs text-background-50/60 mt-1">安全运行率</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}